import { Controller } from "@hotwired/stimulus"

// Direct costs: inline add row + delete, no page reloads.
export default class extends Controller {
  static targets = ["body", "table", "empty"]
  static values = { url: String }

  async create() {
    const body = {}
    this.element.querySelectorAll("[data-new-field]").forEach((el) => { body[el.dataset.newField] = el.value })
    if (!body.amount) return this._showToast("Enter an amount.", "alert")
    try {
      const resp = await fetch(this.urlValue, { method: "POST", headers: this._headers(), body: JSON.stringify(body) })
      const data = await resp.json()
      if (!resp.ok) throw new Error(data.error || "Could not add the cost")
      if (this.hasEmptyTarget) this.emptyTarget.remove()
      this.tableTarget.classList.remove("hidden")
      const esc = (s) => (s || "").toString().replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]))
      this.bodyTarget.insertAdjacentHTML("afterbegin", `
        <tr data-cost-id="${data.id}">
          <td class="px-2 py-1.5 text-gray-500">${esc(data.incurred_on)}</td>
          <td class="px-2 py-1.5">${esc(data.cost_type)}</td>
          <td class="px-2 py-1.5 text-gray-500">${esc(data.category)}</td>
          <td class="px-2 py-1.5">${esc(data.description)}</td>
          <td class="px-2 py-1.5 text-gray-500">${esc(data.vendor)}</td>
          <td class="px-2 py-1.5 text-right tabular-nums font-medium">$${(data.amount || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}</td>
          <td class="px-2 py-1.5 text-right"><button data-action="click->direct-costs#destroy" class="text-gray-300 hover:text-red-500 cursor-pointer">✕</button></td>
        </tr>`)
      this.element.querySelectorAll("[data-new-field]").forEach((el) => {
        if (!["incurred_on", "cost_type"].includes(el.dataset.newField)) el.value = ""
      })
      this._showToast("Cost added")
    } catch (err) {
      this._showToast(err.message, "alert")
    }
  }

  async destroy(e) {
    const row = e.currentTarget.closest("tr")
    const resp = await fetch(`${this.urlValue}/${row.dataset.costId}`, { method: "DELETE", headers: this._headers() })
    if (resp.ok) row.remove()
  }

  _headers() {
    return {
      "Content-Type": "application/json", "Accept": "application/json",
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
    }
  }

  _showToast(message, type = "notice") {
    const div = document.createElement("div")
    div.className = type === "alert" ? "flash-toast-alert" : "flash-toast-notice"
    div.setAttribute("data-controller", "flash")
    div.setAttribute("data-flash-dismiss-after-value", "5000")
    div.textContent = message
    document.body.prepend(div)
  }
}
